module.exports = __webpack_public_path__ + "static/mountains-2a4f89e3fdcdc81d6745111b3a8c65f1.jpg";